import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  withStyles,
  withMobileDialog,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Button,
  Grid,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import { KeyboardDatePicker } from '@material-ui/pickers';
import {
  requestLogs,
  closeLogsModal,
} from '@pingum/app-state-management/log/actions';
import { formatDate } from '../../../utils/dateHelper';

import './styles.scss';

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 250,
  },
  dialog: { width: '100%' },
});

export class AuditLogsModalComponent extends React.Component {
  constructor(props) {
    super(props);
    const startTime = new Date();
    startTime.setDate(startTime.getDate() - 7);
    const endTime = new Date();
    endTime.setDate(endTime.getDate() + 1);

    this.state = {
      startTime,
      endTime,
    };
  }

  refreshData = () => {
    this.props.requestLogs(
      this.props.tenantName,
      this.props.service,
      this.props.actions,
      this.state.startTime,
      this.state.endTime,
    );
  }

  startTimeChange = (e) => {
    const { _d: newTime } = e;
    this.setState({ startTime: new Date(newTime) }, () => {
      this.refreshData();
    });
  }

  endTimeChange = (e) => {
    const { _d: newTime } = e;
    this.setState({ endTime: new Date(newTime) }, () => {
      this.refreshData();
    });
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.props.showLogsModal}
          fullScreen={this.props.fullScreen}
          onClose={this.props.closeLogsModal}
          onEntering={this.refreshData}
          aria-labelledby="form-dialog-title"
          maxWidth="md"
          classes={{ paper: this.props.classes.dialog }}
        >
          <DialogTitle id="form-dialog-title">Audit Logs</DialogTitle>
          <DialogContent>
            {
              this.props.isFetching
                ? (
                  <div className="logs-loading-container">
                    <CircularProgress />
                  </div>
                )
                : <span />
            }
            {
              <div className={this.props.classes.root}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={4}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="MM/DD/YYYY"
                      margin="normal"
                      label="Start Date"
                      value={this.state.startTime}
                      onChange={this.startTimeChange}
                      KeyboardButtonProps={{ 'aria-label': 'Start Date' }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="MM/DD/YYYY"
                      margin="normal"
                      label="End Date"
                      value={this.state.endTime}
                      onChange={this.endTimeChange}
                      KeyboardButtonProps={{ 'aria-label': 'End Date' }}
                    />
                  </Grid>
                </Grid>

                <Grid container>
                  <Grid item xs={12}>
                    <MaterialTable
                      title=""
                      data={this.props.auditLogs}
                      options={{
                        search: false,
                        toolbar: false,
                      }}
                      components={{ Container: Grid }}
                      columns={[
                        {
                          title: 'Action',
                          field: 'action',
                        },
                        {
                          title: 'Date',
                          field: 'date',
                          render: (log) => formatDate(log.date),
                        },
                        {
                          title: 'User',
                          field: 'userEmailDoingAction',
                        },
                        {
                          title: 'Details',
                          field: 'information',
                        },
                      ]}
                    />
                  </Grid>
                </Grid>
              </div>
            }
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.closeLogsModal}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

AuditLogsModalComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  showLogsModal: PropTypes.bool.isRequired,
  closeLogsModal: PropTypes.func.isRequired,
  requestLogs: PropTypes.func.isRequired,
  tenantName: PropTypes.string.isRequired,
  actions: PropTypes.array.isRequired,
  auditLogs: PropTypes.array,
  service: PropTypes.string.isRequired,
  fullScreen: PropTypes.bool,
};

AuditLogsModalComponent.defaultProps = {
  auditLogs: [],
  fullScreen: false,
};

export const mapStateToProps = (state) => ({
  isFetching: state.log.isFetchingAuditLogs,
  auditLogs: state.log.auditLogs,
  showLogsModal: state.log.showLogsModal,
  tenantName: state.log.request.tenantName,
  actions: state.log.request.actions,
  service: state.log.request.service,
});

export const mapDispatchToProps = (dispatch) => ({
  closeLogsModal: () => dispatch(closeLogsModal()),
  requestLogs: (tenantName, service, actions, startTime, endTime) => dispatch(
    requestLogs(tenantName, service, actions, startTime, endTime),
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withMobileDialog({ breakpoint: 'xs' })(AuditLogsModalComponent)));
